export * from './errors';

export enum WeekDays {
  sunday = 'sunday',
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  holiday = 'holiday',
}

export const MONTHS = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

export const BREAKPOINTS = {
  desktop: 1240,
  tablet: 992,
  mobile: 768,
};

// Extraído do calendário do Design System
export const NATIONAL_HOLIDAYS = [
  {
    nome: 'Pascoa',
    move: 0,
  },
  {
    nome: 'Corpus Christi',
    move: 60,
  },
  {
    nome: 'Carnaval',
    move: -47,
  },
  {
    nome: 'Sexta Santa',
    move: -2,
  },
  {
    nome: 'Ano Novo',
    data: '01/01',
  },
  {
    nome: 'Dia internacional da Mulher',
    data: '08/03',
  },
  {
    nome: 'Tiradentes',
    data: '21/04',
  },
  {
    nome: 'Dia do Trabalho',
    data: '01/05',
  },
  {
    nome: 'Dia dos namorados',
    data: '12/06',
  },
  {
    nome: 'Dia da Indepedência do Brasil',
    data: '07/09',
  },
  {
    nome: 'Dia das Crianças',
    data: '12/10',
  },
  {
    nome: 'Nossa Senhora aparecida',
    data: '12/10',
  },
  {
    nome: 'Dia do professor',
    data: '15/10',
  },
  {
    nome: 'Finados',
    data: '02/11',
  },
  {
    nome: 'Proclamação da República',
    data: '15/11',
  },
  {
    nome: 'Natal',
    data: '25/12',
  },
];
